import { ScrollView, Pressable, StyleSheet, Text } from 'react-native';
import { colors, control, fontFamily, radii, spacing } from '~/ui/tokens';

interface FilterPillsProps<T extends string> {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}

export function FilterPills<T extends string>({ options, value, onChange }: FilterPillsProps<T>) {
  return (
    <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.row}>
      {options.map((option) => {
        const active = option.value === value;
        return (
          <Pressable
            key={option.value}
            accessibilityRole="button"
            accessibilityLabel={option.label}
            onPress={() => onChange(option.value)}
            style={[styles.pill, active && styles.pillActive]}
          >
            <Text style={[styles.label, active && styles.labelActive]}>{option.label}</Text>
          </Pressable>
        );
      })}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: spacing(1),
  },
  pill: {
    borderWidth: 1,
    borderColor: colors.line,
    borderRadius: radii.full,
    paddingVertical: spacing(1),
    paddingHorizontal: spacing(2),
    backgroundColor: colors.card,
  },
  pillActive: {
    borderColor: colors.brand,
    backgroundColor: colors.brand,
  },
  label: {
    fontFamily: fontFamily.medium,
    ...control.secondaryCta,
    color: colors.inkSoft,
  },
  labelActive: {
    color: colors.white,
    fontFamily: fontFamily.semibold,
  },
});
